import * as go from 'gojs';
import { withTransaction } from '../../../../../utils/with-transaction';
import { nodeType } from '../../../config/config';
import { refreshGroupBounds } from '../utils/group-bounds-utils';
import { createGroupNode } from './create-group-node';

export const groupObjects = (category: nodeType) => (diagram: go.Diagram, parts: go.Set<go.Part>) => {
  let group: go.Group | null = null;
  withTransaction(
    diagram,
    () => {
      group =
        parts?.filter((p) => p.containingGroup?.category === category)?.first()?.containingGroup ||
        (parts?.filter((p) => p.category === category)?.first() as go.Group) ||
        (createGroupNode(diagram, {
          categoryName: category,
        }) as go.Group);

      diagram.commit((d) => {
        d.commandHandler.addTopLevelParts(parts);
        if (group) {
          group.addMembers(parts, true);
          group.isSelected = true;
        }
      });
    },
    'Group',
  );

  if (group) {
    refreshGroupBounds(group);
  }
};
